<template>
  <span
    class="inline-flex items-center justify-center rounded border border-amber-300 px-1 py-px text-[0.55rem] font-medium leading-none text-amber-500"
  >
    PRO
  </span>
</template>
